<script>
  import Router, { replace } from "svelte-spa-router";
  import Add from "./Add.svelte";
  import Edit from "./Edit.svelte";
  import Detail from "./Detail.svelte";
  import LayoutSidebar from "../../layouts/LayoutSidebar.svelte";
  import List from "./List.svelte";
  import SubmissionList from "./SubmissionList.svelte";
  import LessonSubmission from "./LessonSubmission.svelte";
  import { roleModules } from "../../stores/store";
  import { LEARNING_MODULE } from "../../utils/const";
  import { onMount } from "svelte";
  import { checkRoleModule } from "../../utils/utils";

  const prefix = "/learning";
  const routes = {
    "/": List,
    "/add/:type": Add,
    "/:_id/edit": Edit,
    "/:_id/detail": Detail,
    "/:_id/member": SubmissionList,
    "/:_id/lesson/:_userId": LessonSubmission,
  };

  let openSidebar = false;

  onMount(() => {
    if (!checkRoleModule($roleModules, LEARNING_MODULE)) {
      replace("/");
    }
  });
</script>

<LayoutSidebar bind:openSidebar>
  <div class="md:flex pt-14 mt-8 md:mt-4">
    <div class="w-full md:ml-64">
      <Router {routes} {prefix} />
    </div>
  </div>
</LayoutSidebar>
